import React, {useEffect, useState} from "react"
import ReactModal from 'react-modal'
import styles from "./sngabout.css"


const SNGabout = ({ children }) => {
    return (
        <section className="sngabout" id="SNGabout">
            <div className="containfix">
                <p className="underheader">
                    {children}
                </p>
            </div>
         </section>
    )
}

export default SNGabout